<h4 *ngIf="title">{{title}}</h4>
<div *ngIf="scadenzaForm">
<small id="scadenze-form" class="sr-only">Form Scadenze</small>
<form aria-labelledby="scadenze-form" #f="ngForm" [formGroup]="scadenzaForm" (ngSubmit)="update();">

	<div class="row">
        <div ng-select-combo
			[ngClass]="{'col-sm-3': isAttivitaTipoScadenza, 'col-sm-4': !isAttivitaTipoScadenza}"
            formControlName="tipoScadenza"
            [label]="'Tipo'"
            [required]="true"
            [options]="tipoScadenzaOptions"
            [optionSel]="request.tipoScadenza"
            (onChangeSel)="onChangeTipoScadenza($event);">
		</div>
        <div ng-select-combo 
			[ngClass]="{'col-sm-3': isAttivitaTipoScadenza, 'col-sm-4': !isAttivitaTipoScadenza}"
			formControlName="motivo"
			[label]="'Adempimento'"
			[required]="true"
			[tooltip]="true"
			[options]="motivoScadenzaOptionsFiltrate"
			[optionSel]="request.motivo"
			(onChangeSel)="request.motivo = $event; scadenzaForm.controls['motivo'].setValue($event);">
        </div>
        <div ng-select-combo
			[ngClass]="{'col-sm-3': isAttivitaTipoScadenza, 'col-sm-4': !isAttivitaTipoScadenza}"
			formControlName="priorita"
			[label]="'Priorit&agrave;'"
			[required]="true"
			[options]="prioritaOptions"
			[optionSel]="request.priorita"
			(onChangeSel)="request.priorita = $event; scadenzaForm.controls['priorita'].setValue($event);">
        </div>
		<div *ngIf="isAttivitaTipoScadenza" class="col-sm-3">	
			<!-- [typeahead] = Observable per la ricerca in tempo reale -->
			<!-- filteredAssegnatari$ è un Observable, quindi viene usato | async per sottoscriversi automaticamente 
				 	e ottenere i dati. Quando cambia la lista, il dropdown si aggiorna. -->
			<!-- [items] = Lista degli elementi da mostrare nel dropdown (da un Observable) -->
			<!-- bindLabel	Campo dell'oggetto da mostrare nel dropdown (cognomeNome) -->
			<!-- bindValue	Valore assegnato al form (username) -->
			<label for="assegnatario">Assegnatario</label>
			<ng-select
				[items]="filteredAssegnatari$ | async"
				bindLabel="cognomeNome"
				bindValue="username"
				[typeahead]="searchInput$"
				[typeToSearchText]="'Scrivi per cercare...'"
				placeholder="Cerca un assegnatario"
				formControlName="assegnatario"
				(change)="onAssegnatarioSelected($event)"
				(ngModelChange)="onSearchChange($event)"
				[compareWith]="compareFn">
			</ng-select>
		</div>
    </div>

<!--    <div class="row">-->
<!--		<div comboModInput class="col-sm-4" [labelInput]="'Tipo scadenza'"-->
<!--			formControlName="tipoScadenza" [mandatory]="true"-->
<!--			[objectReference]="request.tipoScadenza"-->
<!--			[control]="scadenzaForm.controls['tipoScadenza']"-->
<!--			(onReturn)="request.tipoScadenza = $event"-->
<!--			[optionsCombo] ="tipoScadenzaOptions"-->
<!--			[ngModel]="request.tipoScadenza"></div>-->
<!--		<div comboModInput class="col-sm-4" [labelInput]="'Motivo scadenza'"-->
<!--			formControlName="motivo" [objectReference]="request.motivo"-->
<!--			(onReturn)="request.motivo = $event"-->
<!--			[optionsCombo] ="motivoScadenzaOptions"-->
<!--			[control]="scadenzaForm.controls['motivo']" [mandatory]="true"-->
<!--			[ngModel]="request.motivo"></div>-->
<!--		<div comboModInput class="col-sm-4" [labelInput]="'Priorit&agrave;'"-->
<!--			formControlName="priorita" [objectReference]="request.priorita"-->
<!--			(onReturn)="request.priorita = $event"-->
<!--			[optionsCombo] ="prioritaOptions"-->
<!--			[control]="scadenzaForm.controls['priorita']" [mandatory]="true"-->
<!--			[ngModel]="request.priorita"></div>-->
<!--	</div>-->
	<div class="row">
		<div datePickerInput class="col-sm-3"
			[control]="scadenzaForm.controls['dataScadenza']"
			[labelInput]="'Data'" [mandatory]="true"
			formControlName="dataScadenza" [(ngModel)]="request.dataScadenza"></div>
		<div oraComboInput formControlName="ora" [objectReferenceOra]="oraSet"
			[objectReferenceMin]="minSet" (onReturn)="ora = $event"></div>
		<div datePickerInput class="col-sm-3" [labelInput]="'Data promemoria'"
			formControlName="dataPromemoria" [(ngModel)]="request.dataPromemoria"></div>
		<div checkBoxRadio class="col-sm-2" [labelInput]="'Pubblico'"
			idInput="pubblica" formControlName="pubblica"
			[objectReference]="request.pubblica"
			(onReturn)="request.pubblica = $event"></div>
	</div>
	<div class="row">
		<div checkBoxRadio class="col-sm-3" [labelInput]="'Evasione'"
			idInput="evasa_{{!!request.id ? 'modifica' : 'creazione'}}" formControlName="evasa"
			[objectReference]="request.evasa" (onReturn)="onEvasa($event)"></div>
		<div ng-select-combo class="col-sm-3"
			formControlName="motivoEvasione"
		   [label]="'Motivo evasione'"
		   [required]="false"
		   [disabled]="!request.evasa"
		   [options]="motivoEvasioneOptions"
		   [optionSel]="request.motivoEvasione"
		   (onChangeSel)="request.motivoEvasione = $event">
	   </div>
		<div datePickerInput class="col-sm-3" [labelInput]="'Data evasione'" [mandatory]="request.evasa"
			formControlName="dataEvasione" [(ngModel)]="request.dataEvasione" [submitPending]="!request.evasa"></div>
		<div textInput [control]="scadenzaForm.controls['appunto']"
			class="col-sm-3" [labelInput]="'Appunto (max 255)'" formControlName="appunto"
			[(ngModel)]="request.appunto"></div>
	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="request.note"></div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'" [disabled]="!scadenzaForm.valid || (request.evasa && !request.dataEvasione)"></p>
	</div>
</form>
</div>
